// src/components/ui/Form.js
import React from 'react';

// Main container for the form, provides vertical spacing.
export const FieldGroup = ({ children }) => (
  <div className="flex flex-col gap-6">{children}</div>
);

// A fieldset for grouping related fields.
export const FieldSet = ({ children }) => (
  <fieldset className="flex flex-col gap-4">{children}</fieldset>
);

// The title for a FieldSet.
export const FieldLegend = ({ children }) => (
  <legend className="text-lg font-semibold leading-6">{children}</legend>
);

// A description for a FieldSet or a specific Field.
export const FieldDescription = ({ children }) => (
  <p className="text-sm text-gray-500 dark:text-gray-400">{children}</p>
);

// A container for a single form control (label, input, description).
export const Field = ({ children }) => (
  <div className="grid gap-2">{children}</div>
);

// The label for a form control.
export const FieldLabel = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="text-sm font-medium leading-none">
    {children}
  </label>
);